module.exports = __webpack_public_path__ + "static/media/dropdown_white.91a9f75b.svg";